module.exports = __webpack_public_path__ + "img/leather-icon.5a688faa.png";